import { useState } from 'react'
import { Link } from 'react-router-dom'
import { Linkedin } from 'lucide-react'
import { NavigationMenu } from './NavigationMenu'

type FooterProps = {
  onNavigate: (href: string) => void
}

export function Footer({ onNavigate }: FooterProps) {
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  const toggleMenu = () => setIsMenuOpen(prev => !prev)

  const handleNavigation = (href: string) => {
    setIsMenuOpen(false)
    onNavigate(href)
  }

  return (
    <footer className="fixed inset-x-0 bottom-0 z-20">
      <div className="px-12 py-4 flex justify-between items-center">
        <div className="flex items-center gap-2">
          <button 
            onClick={toggleMenu}
            className="font-mono text-gray-800 hover:text-gray-600 transition-colors dark:text-gray-200 dark:hover:text-gray-400"
            aria-expanded={isMenuOpen}
            aria-controls="navigation-menu"
          >
            /navigation/
          </button>
          <div className="h-2.5 w-2.5 rounded-full bg-red-500 animate-blink" />
        </div>
        <div className="flex items-center gap-2 font-mono text-xs">
          <a href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-gray-600 transition-colors">
            <Linkedin size={16} />
          </a>
          <span className="text-gray-400">|</span>
          <Link to="/legal" className="text-gray-400 hover:text-gray-600 transition-colors">
            Terms of Service and Privacy Policy
          </Link>
        </div>
      </div>
      <NavigationMenu 
        id="navigation-menu" 
        isOpen={isMenuOpen} 
        onClose={() => setIsMenuOpen(false)}
        onNavigate={handleNavigation}
      />
    </footer>
  )
} 